import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import {
    useGetVendorQuotationDetailQuery,
    useUpdateVendorQuotationMutation,
} from "store/services/vendorQuotationApi";
import { useAppMeta } from "hooks";
import VendorQuotationForm from "./vendorQuotationComponents/VendorQuotationForm";

const VendorQuotationEditScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Vendor Quotations", path: "/app/crm/vendor-quotation/list" },
        { title: "Edit Vendor Quotation" },
    ];

    const {
        data: vendorQuotationDetail,
        isLoading: loadingVendorQuotation,
        error,
    } = useGetVendorQuotationDetailQuery(id);

    const [updateVendorQuotation, { isLoading: updatingVendorQuotation }] =
        useUpdateVendorQuotationMutation();

    const handleUpdate = async (data) => {
        try {
            await updateVendorQuotation({ _id: id, ...data }).unwrap();
            toast.success("Vendor Quotation successfully updated!");
            navigate(`/app/crm/vendor-quotation/${id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't update Vendor Quotation!"
            );
        }
    };

    useAppMeta("Edit Vendor Quotation");

    return (
        <BreadcrumbLayout
            breadcrumbs={breadcrumbs}
            isBusy={loadingVendorQuotation || updatingVendorQuotation}
        >
            <BreadcrumbLayout.Error error={error} />
            <BreadcrumbLayout.Paper>
                <VendorQuotationForm
                    isBusy={loadingVendorQuotation || updatingVendorQuotation}
                    vendorQuotationDetail={vendorQuotationDetail}
                    onSubmit={handleUpdate}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorQuotationEditScreen;